function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import { BehaviorEventRow } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/event-row';
import { useBehaviorsList } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/common/behaviors-list';
import { getEmptyEventMetricEntryBehavior } from 'common/query-builder/query-entry-section/row-types/new-metric-entry/utils';
import { useTranslation } from 'common/i18n/hooks';
import type { RowProps } from '../catalog';
import styles from './index.module.styl';

/**
 * Renders a behavior definition for specifying multiple event conditions a user can be matched
 * on, this mimics the functionality of custom events.
 */
export function SimpleBehaviorDefinition(props: RowProps) {
  var _props$entry$behavior;
  const {
    t
  } = useTranslation();
  const hasMultipleEvents = ((_props$entry$behavior = props.entry.behavior.behaviors) !== null && _props$entry$behavior !== void 0 ? _props$entry$behavior : []).length > 1;
  const {
    behaviors,
    handleAddBehavior,
    handleUpdateBehavior,
    handleDeleteBehavior,
    handleDuplicateBehavior
  } = useBehaviorsList(props.entry, props.updateEntry);
  return <div className={styles.simpleBehavior} data-sentry-component="SimpleBehaviorDefinition" data-sentry-source-file="behavior-definition.tsx">
      {behaviors.map((subBehavior, index) => {
      return <BehaviorEventRow {...props} enableCohortFilters behavior={subBehavior}
      // @todo(metrics) Figure out a way to uniquely identify each behavior in a metric
      // key={index}
      onDelete={hasMultipleEvents ? () => handleDeleteBehavior(index) : null} onDuplicate={() => handleDuplicateBehavior(index)} onSelect={behavior => handleUpdateBehavior(index, behavior)} suffixLabel={hasMultipleEvents && index !== behaviors.length - 1 ? " or" : null} />;
    })}

      <BehaviorEventRow {...props} hideControls behavior={_objectSpread(_objectSpread({}, getEmptyEventMetricEntryBehavior()), {}, {
      name: t("query-builder.metrics.add-to-definition")
    })} onSelect={behavior => handleAddBehavior(behavior)} data-sentry-element="BehaviorEventRow" data-sentry-source-file="behavior-definition.tsx" />
    </div>;
}